import { render } from "./ContactEventDetails.vue?vue&type=template&id=0e149463"
import script from "./ContactEventDetails.vue?vue&type=script&lang=js"
export * from "./ContactEventDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__